import axios from "../../api/axios";

export const useRefreshToken = () => {
  const refreshToken = async (props) => {
    const { access_token, refresh_token } = props;
    try {
      const { data } = await axios.post(
        "refresh",
        { refresh_token },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
            Accept: "application/json",
          },
        }
      );

      return data;
    } catch (err) {
      console.log(err);
    }
  };

  return refreshToken;
};
